import Swiper, { Navigation, Pagination } from "swiper";

export default function ContentCarousel() {
    document.querySelectorAll(".content-carousel-cards").forEach((el) => {
        const swiper = new Swiper(el, {
            spaceBetween: 15,
            slidesPerView: "auto",
            centeredSlides: true,
            modules: [Navigation, Pagination],
            loop: true,
            navigation: {
                nextEl: el.closest('.slider-wrapper').querySelector(".sw-next"),
                prevEl: el.closest('.slider-wrapper').querySelector(".sw-prev"),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    });

    document.querySelectorAll(".content-carousel-incremental").forEach((el) => {
        const wrapper = el.closest('.content-carousel');
        const swiperInc = new Swiper(el, {
            slidesPerView: "auto",
            spaceBetween: 95,
            loop: true,
            modules: [Navigation, Pagination],
            pagination: {
                el: wrapper.querySelector(".swiper-pagination"),
                type: "fraction",
                formatFractionCurrent: addZero,
                formatFractionTotal: addZero
            },
            navigation: {
                nextEl: wrapper.querySelector(".swiper-next"),
                prevEl: wrapper.querySelector(".swiper-prev"),
            },
            on: {
                afterInit: function () {
                    $(".content-carousel-incremental .swiper-slide").each(
                        function () {
                            let idx = $(this).data("swiper-slide-index") + 1;
                            let addZero = idx > 9 ? idx : "0" + idx;
                            $(this).find(".counter").html(addZero);
                        }
                    );
                },
            },
            breakpoints: {
                768: {
                    slidesPerView: "1.44",
                },
            },
        });
    });

    document.querySelectorAll(".content-carousel-singleton").forEach((el) => {
        const swiperSingle = new Swiper(el, {
            modules: [Navigation, Pagination],
            loop: true,
            centeredSlides: true,
            slidesPerView: "auto",
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
        });
    });
}

function addZero(num){
    return (num > 9) ? num : '0' + num;
}
